import {
  GET_NEWSLETTER,
  GET_NEWSLETTER_SUCCESS,
  GET_NEWSLETTER_ERROR,
  GET_NEWSLETTERS,
  GET_NEWSLETTERS_SUCCESS,
  GET_NEWSLETTERS_ERROR,
  GET_SUBSCRIPTION,
} from "../../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_NEWSLETTER:
    case GET_NEWSLETTERS: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_NEWSLETTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: action.payload,
      };
    }

    case GET_NEWSLETTERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: action.payload,
      };
    }

    case GET_NEWSLETTER_ERROR:
    case GET_NEWSLETTERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    case GET_SUBSCRIPTION: {
      return {
        ...state,
        data: null,
      };
    }

    default: {
      return state;
    }
  }
};
